const personalHomepage = {
  path: 'personalHomepage',
  meta: { index: 2 },
  component: resolve => require(['../../../../../components/pages/student_user/student/personalHomepage/index'], resolve)
}
export default personalHomepage



// WEBPACK FOOTER //
// ./src/router/pages/student_user/student/personalHomepage/index.js